// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { dispatchEvent } from 'fg-frontend/src/lib/dom';
import { isTouchDevice } from 'fg-frontend/plugins/utils';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  OVERLAY: '[data-fragment="EshopHeader.overlay"]',
  MENU: '[data-fragment="EshopHeader.menu"]',
  MENU_RWD: '[data-fragment="EshopHeader.menuRwd"]',
  MENU_RWD_TOGGLE: '[data-fragment="EshopHeader.menuRwdToggle"]',
  MENU_RWD_TOGGLE_ICO: '[data-fragment="EshopHeader.menuRwdToggleIco"]',
  MENU_RWD_TOGGLE_LABEL: '[data-fragment="EshopHeader.menuRwdToggleLabel"]',
  MENU_MEGAMENU_ITEM: '[data-fragment="EshopHeader.menuMegamenuItem"]',
  MENU_MEGAMENU_ITEM_LINK: '[data-fragment="EshopHeader.menuMegamenuItemLink"]',
  MENU_ITEM_TOGGLE: '[data-fragment="EshopHeader.menuItemToggle"]',
  MENU_ITEM_BACK: '[data-fragment="EshopHeader.menuItemBack"]',
  MENU_SUBMENU_ITEM: '.submenu__list-item--child [data-fragment="EshopHeader.menuSubmenuItem"]',
  HEADER_ESHOP: '[data-fragment="EshopHeader.headerEshop"]',
  HEADER_MENU: '[data-fragment="EshopHeader.headerMenu"]',
  HEADER_MENU_CONTENT: '[data-fragment="EshopHeader.headerMenuContent"]',
  HEADER_REGISTRATION: '[data-fragment="EshopHeader.headerRegistration"]',
  HEADER_INFO_RWD: '[data-fragment="EshopHeader.headerInfoRwd"]',
  HEADER_FULLTEXT: '[data-fragment="EshopHeader.headerFulltext"]',
  FULLTEXT: '[data-fragment="EshopHeader.fulltext"]',
  FULLTEXT_RWD_TOGGLE: '[data-fragment="EshopHeader.fulltextRwdToggle"]',
};

export default class EshopHeader extends WebComponent {
  constructor(props) {
    super(props);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.handleToggleFulltext = this.handleToggleFulltext.bind(this);
    this.handleSubmenuBackBtn = this.handleSubmenuBackBtn.bind(this);
    this.handleToggleSubmenu2nd = this.handleToggleSubmenu2nd.bind(this);
    this.handleToggleSubmenu3rd = this.handleToggleSubmenu3rd.bind(this);
    this.handleToggleMegamenuEnter = this.handleToggleMegamenuEnter.bind(this);
    this.handleToggleMegamenuClick = this.handleToggleMegamenuClick.bind(this);
    this.handleToggleMegamenuLeave = this.handleToggleMegamenuLeave.bind(this);
    this.handleClickOverlay = this.handleClickOverlay.bind(this);

    this.overlayActive = false;
    this.megamenuActive = false;
    this.waitingForMegamenuClose = false;
    this.megamenuActiveItem = '';
    this.megamenuCurrentItem = '';
    this.waitingForMegamenuItem = '';
    this.rwdMenuActive = false;
    this.fulltextActive = false;
    this.timer = null;

    this.state = {
      tabletMenuOpened: false,
    };
  }
  didMount() {
    // clone eshop header to primary header container - project specific
    this.cloneHeaderEshop();

    window.addEventListener('cartAddition', () => {
      window.setTimeout(()=> {
        this.cloneHeaderEshop();
      },200);
    });

    // common elements
    this.body = document.querySelector('body');
    this.overlay = document.querySelector(fragments.OVERLAY);

    // menu elements
    this.menu = this.element.querySelector(fragments.MENU);
    this.menuContent = this.element.querySelector(fragments.HEADER_MENU_CONTENT);
    this.menuMegamenuItems = this.element.querySelectorAll(fragments.MENU_MEGAMENU_ITEM);
    this.menuMegamenuItemLinks = this.element.querySelectorAll(fragments.MENU_MEGAMENU_ITEM_LINK);
    this.menuRwdToggle = this.element.querySelector(fragments.MENU_RWD_TOGGLE);
    this.menuItemsToggle = this.element.querySelectorAll(fragments.MENU_ITEM_TOGGLE);
    this.menuRwd = this.element.querySelector(fragments.MENU_RWD);
    this.menuRwdToggleIco = this.element.querySelector(fragments.MENU_RWD_TOGGLE_ICO);
    this.menuRwdToggleLabel = this.element.querySelector(fragments.MENU_RWD_TOGGLE_LABEL);
    this.menuItemsBack = this.element.querySelectorAll(fragments.MENU_ITEM_BACK);
    this.menuSubmenuItems = this.element.querySelectorAll(fragments.MENU_SUBMENU_ITEM);

    // layout elements
    this.headerEshop = this.element.querySelector(fragments.HEADER_ESHOP);
    this.headerInfoRwd = this.element.querySelector(fragments.HEADER_INFO_RWD);
    this.headerRegistration = this.element.querySelector(fragments.HEADER_REGISTRATION);
    this.headerMenu = this.element.querySelector(fragments.HEADER_MENU);
    this.headerFulltext = this.element.querySelector(fragments.HEADER_FULLTEXT);

    // fulltext elements
    this.fulltext = this.element.querySelector(fragments.FULLTEXT);
    this.fulltextRwdToggles = this.element.querySelectorAll(fragments.FULLTEXT_RWD_TOGGLE);

    // bind events
    this.menuRwdToggle.addEventListener('click', this.handleToggleMenu);
    this.menuItemsBack.forEach((btn) => {
      btn.addEventListener('click', this.handleSubmenuBackBtn);
    });
    this.menuItemsToggle.forEach((btn) => {
      btn.addEventListener('click', this.handleToggleSubmenu2nd);
    });
    this.menuSubmenuItems.forEach((item) => {
      item.addEventListener('click', this.handleToggleSubmenu3rd);
    });
    this.menuMegamenuItems.forEach((item) => {
      if (!isTouchDevice()) {
        item.addEventListener('mouseenter', this.handleToggleMegamenuEnter);
        item.addEventListener('mouseleave', this.handleToggleMegamenuLeave);
      }
    });
    this.menuMegamenuItemLinks.forEach((item) => {
      if (isTouchDevice()) {
        item.addEventListener('click', this.handleToggleMegamenuClick);
      }
    });

    this.fulltextRwdToggles.forEach((btn) => {
      btn.addEventListener('click', this.handleToggleFulltext);
    });

    this.body.addEventListener('click', this.handleClickOverlay);
  }

  handleClickOverlay(e) {
    const {
      hoverClass,
    } = this.props;

    if (this.overlayActive && this.megamenuActive && (!this.element.contains(e.target) && this.element != e.target)) {
      this.overlayActive = false;
      this.megamenuActive = false;
      this.setState({ tabletMenuOpened: false });
      if (this.megamenuActiveItem) {
        this.megamenuActiveItem.classList.remove(hoverClass);
      }
    }

    if (this.overlayActive && this.fulltextActive && (!this.fulltext.contains(e.target) && this.fulltext != e.target) && (!this.headerFulltext.contains(e.target) && this.headerFulltext != e.target)) {
      this.handleToggleFulltext();
    }
  }

  handleToggleMegamenuClick(e) {
    const {
      hoverClass,
      megamenuBreakpoint,
    } = this.props;

    const parentLI = e.target.parentElement.parentElement;

    if (window.innerWidth >= megamenuBreakpoint && !e.target.classList.contains('submenu__list-item-link')) {
      e.preventDefault();
      // if not active
      if (!parentLI.classList.contains(hoverClass)) {
        // remove from all and set current
        this.menuMegamenuItems.forEach((item) => {
          item.classList.remove(hoverClass);
        });
        this.setState({ tabletMenuOpened: true });
        this.overlayActive = true;
        this.megamenuActive = true;
        parentLI.classList.add(hoverClass);
        this.megamenuActiveItem = parentLI;
      } else {
        parentLI.classList.remove(hoverClass);
        this.overlayActive = false;
        this.megamenuActive = false;
        this.setState({ tabletMenuOpened: false });
      }
    }
  }

  handleToggleMegamenuEnter(e) {
    const {
      activeClass,
      hoverClass,
      megamenuBreakpoint,
      bodyMegamenuActiveClass,
      bodyOverlayActiveClass,
    } = this.props;

    if (window.innerWidth >= megamenuBreakpoint) {
      this.megamenuCurrentItem = e.target;

      if (this.megamenuActiveItem == '') {
        this.megamenuActiveItem = e.target;

        clearTimeout(this.timer);
        this.overlay.classList.add(activeClass);
        this.overlayActive = true;
        this.megamenuActive = true;
        this.body.classList.add(bodyMegamenuActiveClass);
        this.body.classList.add(bodyOverlayActiveClass);
        this.body.classList.remove('fulltext-autocomplete--active');
        e.target.classList.add(hoverClass);
        this.waitingForMegamenuClose = false;
      }
      else{
        if (e.target == this.megamenuActiveItem) {
          this.waitingForMegamenuClose = false;
          clearTimeout(this.timer);
        }
        else {
          this.waitingForMegamenuItem = e.target;
          this.waitingForMegamenuClose = true;
        }
      }
    }
  }

  handleToggleMegamenuLeave(e) {
    const {
      activeClass,
      hoverClass,
      megamenuTimerInterval,
      megamenuBreakpoint,
      bodyMegamenuActiveClass,
      bodyOverlayActiveClass,
    } = this.props;

    if (window.innerWidth >= megamenuBreakpoint) {
      clearTimeout(this.timer);
      this.megamenuCurrentItem = '';

      this.timer = window.setTimeout(()=>{
        this.overlay.classList.remove(activeClass);
        this.overlayActive = false;
        this.megamenuActive = false;
        if (this.megamenuActiveItem != '') {
          this.megamenuActiveItem.classList.remove(hoverClass);
          this.megamenuActiveItem = '';
        }

        this.body.classList.remove(bodyMegamenuActiveClass);
        this.body.classList.remove(bodyOverlayActiveClass);

        if (this.waitingForMegamenuClose) {
          this.waitingForMegamenuClose = false;
          if (this.megamenuCurrentItem != '') {
            dispatchEvent(this.waitingForMegamenuItem, 'mouseenter');
          }
        }
      }, megamenuTimerInterval);
    }
  }

  handleToggleSubmenu2nd(e) {
    const {
      activeClass,
      lastOfTypeClass,
    } = this.props;

    const trigger = e.target;
    const link = trigger.previousElementSibling;
    const subMenu = trigger.parentElement.nextElementSibling;
    trigger.classList.toggle(activeClass);
    link.classList.toggle(activeClass);
    subMenu.classList.toggle(activeClass);
    subMenu.classList.add(lastOfTypeClass);

    this.menuContent.style.minHeight = subMenu.offsetHeight + 'px';
  }

  handleToggleSubmenu3rd(e) {
    const {
      activeClass,
      lastOfTypeClass,
      megamenuBreakpoint,
    } = this.props;
    if (window.innerWidth < megamenuBreakpoint) {
      e.preventDefault();
      e.target.nextElementSibling.classList.toggle(activeClass);
      const popUps = document.querySelectorAll('.submenu__popup.active');
      popUps.forEach((popup)=>{
        popup.classList.remove(lastOfTypeClass);
      });
      setTimeout(() => {
        popUps.forEach((popup)=>{
          popup.scroll({
            top: 0,
            behavior: 'smooth',
          });
        });
      }, 400);
      e.target.nextElementSibling.classList.add(lastOfTypeClass);
      this.menuContent.style.minHeight = e.target.nextElementSibling.offsetHeight + 'px';
    }
  }

  handleSubmenuBackBtn(e) {
    const {
      activeClass,
      lastOfTypeClass,
    } = this.props;

    const parentPopup = e.target.parentElement.closest('.submenu__popup');

    if (parentPopup) {
      parentPopup.classList.toggle(activeClass);
      parentPopup.classList.remove(lastOfTypeClass);
      const popUps = document.querySelectorAll('.submenu__popup.active');
      popUps.forEach((popup)=>{
        popup.classList.add(lastOfTypeClass);
      });
      this.menuContent.style.minHeight = '';
    }
  }

  handleToggleMenu() {
    const {
      activeClass,
      bodyOverlayActiveClass,
    } = this.props;

    if (this.rwdMenuActive) {
      this.rwdMenuActive = false;
    }
    else {
      this.rwdMenuActive = true;
    }
    if (this.fulltextActive && this.rwdMenuActive) {
      this.handleToggleFulltext();
    }
    this.menuRwdToggle.classList.toggle(activeClass);
    this.overlay.classList.toggle(activeClass);
    this.headerMenu.classList.toggle(activeClass);
    this.menu.classList.toggle(activeClass);
    this.menuRwd.classList.toggle(activeClass);
    this.headerEshop.classList.toggle(activeClass);
    this.headerInfoRwd.classList.toggle(activeClass);
    this.headerRegistration.classList.toggle(activeClass);
    this.menuRwdToggleIco.classList.toggle(activeClass);
    this.menuRwdToggleLabel.classList.toggle(activeClass);
    this.overlayActive = !this.overlayActive;
    this.body.classList.toggle(bodyOverlayActiveClass);
  }

  handleToggleFulltext() {
    const {
      activeClass,
      bodyOverlayActiveClass,
    } = this.props;

    if (this.fulltextActive) {
      this.fulltextActive = false;
    }
    else {
      this.fulltextActive = true;

      document.querySelector('.form-fulltext__input').focus();
    }
    if (this.fulltextActive && this.rwdMenuActive) {
      this.handleToggleMenu();
    }
    this.headerFulltext.classList.toggle(activeClass);
    this.fulltext.classList.toggle(activeClass);
    this.overlay.classList.toggle(activeClass);
    this.overlayActive = !this.overlayActive;
    this.body.classList.toggle(bodyOverlayActiveClass);
  }

  cloneHeaderEshop() {
    //clone header eshop
    const target =  this.element.querySelector('.header__eshop-rwd');

    target.innerHTML = '';

    this.headerEshop = this.element.querySelector('#userLists');
    this.headerEshopClone = this.headerEshop.cloneNode(true);
    this.headerEshopClone.id = 'userListsRwd';

    target.appendChild(this.headerEshopClone);
  }

  update() {
    const {
      tabletMenuOpened,
    } = this.state;

    classNames(this.overlay, { 'active': tabletMenuOpened });
    classNames(this.body, { 'overlay--active': tabletMenuOpened });
  }
}

EshopHeader.defaultProps = {
  activeClass: 'active',
  lastOfTypeClass: 'last-of-type',
  hoverClass: 'hover',
  megamenuTimerInterval: 500,
  megamenuBreakpoint: 768,
  bodyMegamenuActiveClass: 'megamenu--opened',
  bodyOverlayActiveClass: 'overlay--active',
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopHeader.js